import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-4 z-50">
      <a href="tel:+243828706717" className="bg-blue-600 text-white p-4 rounded-full shadow-xl hover:scale-110 transition"><Phone size={24} /></a>
      <a href="https://wa.me/243828706717" target="_blank" rel="noreferrer" className="bg-green-500 text-white p-4 rounded-full shadow-xl hover:scale-110 transition"><MessageCircle size={24} /></a>
    </div>
  );
};
export default FloatingButtons;
